import { Link } from "react-router-dom";

const HIGHLIGHTS = [
  { icon: "ri-film-line", title: "多元题材", desc: "覆盖电影与电视剧，从悬疑犯罪到科幻年代" },
  { icon: "ri-award-line", title: "专业呈现", desc: "系统的作品资料与人物档案，清晰可查" },
  { icon: "ri-flashlight-line", title: "即时动态", desc: "第一时间同步片场资讯与作品最新进展" },
];

export default function SiteIntro() {
  return (
    <section className="bg-background-100 py-14 md:py-20 mt-4">
      <div className="w-full px-4 md:px-8 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
        <div>
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            <i className="ri-information-line" />
            关于本站
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 leading-tight">
            走近筱田优的影视世界
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-5 leading-relaxed">
            本站是「筱田优」影视品牌的官方网站，以人物与作品为核心，系统整理其影视资讯、代表作品与主创阵容，
            为影迷提供一个清晰、专业、易于浏览的内容门户。
          </p>
          <p className="text-sm md:text-base text-foreground-600 mt-4 leading-relaxed">
            在这里，你可以追踪最新影视动态，查阅每一部作品的详细资料，了解台前幕后的创作故事，
            全面认识筱田优在光影之间的每一次表达。
          </p>
          <div className="flex flex-wrap items-center gap-3 mt-7">
            <Link
              to="/about"
              className="px-6 h-11 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap flex items-center gap-2"
            >
              品牌故事
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/contact"
              className="px-6 h-11 rounded-md border border-background-300 text-foreground-700 text-sm font-medium hover:border-primary-400 hover:text-primary-600 transition-colors whitespace-nowrap flex items-center"
            >
              联系我们
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-1 gap-4">
          {HIGHLIGHTS.map((item) => (
            <div
              key={item.title}
              className="flex items-start gap-4 p-5 rounded-lg bg-background-50 border border-background-200"
            >
              <div className="w-11 h-11 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center shrink-0">
                <i className={`${item.icon} text-xl`} />
              </div>
              <div>
                <h3 className="font-heading text-base font-bold text-foreground-900">{item.title}</h3>
                <p className="text-sm text-foreground-500 mt-1 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}